import http from '../utils/fetch';
export default {
    baseurl:'/api/swyl/v1/demo/bscPromotionActivities',
    //分页查询
    selectActivitiesPage(f) {
        return http({
            url: this.baseurl+'/selectActivitiesPage',
            method: 'post',
            params: f
        });
    },
    //新增
    saveActivities(f){
        return http({
            url: this.baseurl+'/saveActivities',
            method: 'post',
            data: f
        });
    },
    //详情
    selectActivityById(f){
        return http({
            url: this.baseurl+'/selectActivityById?activityId=' + f,
            method: 'post',
        });
    },
    //修改
    updateActivities(f){
        return http({
            url: this.baseurl+'/updateActivities',
            method: 'post',
            data: f
        });
    },
    //删除
    deleteActivitiesByIds(f){
        return http({
            url: this.baseurl+'/deleteActivitiesByIds',
            method: 'post',
            data: f
        });
    },
    //获取产品
    getProductList(f){
        return http({
            url: this.baseurl+'/selectProductsList',
            method: 'post',
            data: f
        });
    }
}